export default __webpack_public_path__ + "static/media/about.84cf1ece.jpeg";